'use strict';
exports.__esModule = true;

const _ = require('lodash');
const atomic = require('../../git_modules/@tomandco/atomic/config');
const { button } = require('./atomic/button');
const { input } = require('./atomic/input');
const { color, namedColor } = require('./atomic/color');
const { gridSize, itemsInRow } = require('./atomic/grid');
const { ratio } = require('./atomic/ratio');
const { fontFamily, fontWeight, fontStyle, textStyle } = require('./atomic/typography');
const { componentSize } = require('./atomic/component');

/**
 * @internal
 */
const colorDefault = _.find(color, { key: '1' }).value;
const fontFamilyDefault = _.find(fontFamily, { key: '1' }).value;
const borderColorDefault = _.find(color, { key: '4' }).value;

// Export none converted options to iCMS, but with atomic prefixes
exports.color = atomic.assignKeyPrefix(color, atomic.PREFIX.color);
exports.backgroundColor = atomic.assignKeyPrefix(color, atomic.PREFIX.backgroundColor);
exports.ratio = atomic.assignKeyPrefix(ratio, atomic.PREFIX.ratio);
exports.fontFamily = atomic.assignKeyPrefix(fontFamily, atomic.PREFIX.fontFamily);
exports.fontWeight = atomic.assignKeyPrefix(fontWeight, atomic.PREFIX.fontWeight);
exports.button = button;
exports.input = input;
exports.gridSize = gridSize;
exports.itemsInRow = itemsInRow;
exports.fontStyle = fontStyle;
exports.textStyle = textStyle;

/**
 * Every section of the config file is optional, so you only have to specify what you'd like to change.
 * Any missing sections will fall back to Atomic default configuration.
 */
exports.config = _.defaultsDeep(
    {
        background: {
            color: atomic.convert(color)
        },
        body: {
            background: {
                color: 'transparent'
            },
            color: colorDefault,
            font: {
                family: fontFamilyDefault,
                weight: fontWeight.regular
            }
        },
        border: {
            color: {
                default: borderColorDefault,
                ...atomic.convert(color)
            }
        },
        breakpoint: {
            s: {
                limit: {
                    min: 0,
                    max: 0
                }
            },
            m: {
                limit: {
                    min: 0,
                    max: 0
                }
            },
            l: {
                limit: {
                    min: 0,
                    max: 0
                }
            },
            x: {
                limit: {
                    min: 0,
                    max: 0
                }
            }
        },
        color: atomic.convert(color),
        // grid
        grid: {
            gutter: {
                size: {
                    s: '4px',
                    m: '3px',
                    l: '3px',
                    x: '3px'
                }
            }
        },
        // layout
        layout: {
            width: '2400px' // 1680px + 4 * 12px + 4 * 12px
        },
        margin: {
            max: 20,
            custom: [-4, -2, -1, 22, 26]
        },
        padding: {
            max: 20,
            custom: [-4, -1, 20, 22, 23]
        },
        position: {
            custom: [-12, -7, -4, 5, 7, 10]
        },
        namedColor: namedColor,
        // ratio
        ratio: atomic.convert(ratio),
        // component
        component: {
            size: atomic.convert(componentSize)
        },
        size: {
            s: '4px',
            m: '4px',
            l: '4px',
            x: '4px'
        },
        // typography
        typography: {
            size: {
                s: '16px',
                m: '16px',
                l: '16px',
                x: '16px'
            },
            font: {
                family: atomic.convert(fontFamily),
                weight: atomic.convert(fontWeight)
            }
        }
    },
    atomic.config
);
